export var universes = [{
  id: 'storefront',
  label: 'Escaparate'
}, {
  id: 'sameCategory',
  label: 'Categoría'
}, {
  id: 'sameManagementCompany',
  label: 'Gestora'
}, {
  id: 'mostViewed',
  label: 'Más vistos'
}, {
  id: 'mostComparedWith',
  label: 'Más comparados con este producto'
}, {
  id: 'srri',
  label: 'Mismo perfil inversor'
}];
export var axis = {
  xAxis: {
    label: ''
  },
  yAxis: {
    label: ''
  }
};
export var axisDimensions = [{
  id: 'ogc',
  label: 'Gastos corrientes',
  value: {
    dimension: 'fee',
    fee: 'OGC',
    unit: '%'
  }
}, {
  id: 'r12',
  label: 'Rentabilidad a 12 meses',
  value: {
    dimension: 'performance',
    type: 'accumulated',
    period: 'M12',
    unit: '%'
  }
}, {
  id: 'r36',
  label: 'Rentabilidad a 36 meses',
  value: {
    dimension: 'performance',
    type: 'annualized',
    period: 'M36',
    unit: '%'
  }
}, {
  id: 'r120',
  label: 'Rentabilidad a 10 años',
  value: {
    dimension: 'performance',
    type: 'annualized',
    period: 'M120',
    unit: '%'
  }
}, {
  id: 'sd36',
  label: 'Volatilidad 36 meses',
  value: {
    dimension: 'stat',
    stat: 'standardDeviation',
    period: 'M36',
    unit: '%'
  }
}, {
  id: 'beta36',
  label: 'Beta 36 meses',
  value: {
    dimension: 'stat',
    stat: 'beta',
    period: 'M36',
    unit: ''
  }
}, {
  id: 'alpha36',
  label: 'Alpha 36 meses',
  value: {
    dimension: 'stat',
    stat: 'alpha',
    period: 'M36',
    unit: ''
  }
}, {
  id: 'sharpeRatio',
  label: 'Ratio de Sharpe 36M',
  value: {
    dimension: 'stat',
    stat: 'sharpeRatio',
    period: 'M36',
    unit: ''
  }
}, {
  id: 'maxDrawdown',
  label: 'Máxima caída 36M',
  value: {
    dimension: 'stat',
    stat: 'maxDrawdown',
    period: 'M36',
    unit: '%'
  }
}, {
  id: 'trackingError',
  label: 'Tracking Error',
  value: {
    dimension: 'stat',
    stat: 'trackingError',
    period: 'M36',
    unit: ''
  }
}, {
  id: 'r2',
  label: 'R cuadrado',
  value: {
    dimension: 'stat',
    stat: 'r2',
    period: 'M36',
    unit: ''
  }
}];